import React from "react";

import "./styles.scss"
import ChatHistoryMain from "../../esg-chat/chat-history";

const InvestorHistory = () => {
    return (
        <>
            <ChatHistoryMain model="Investor" searchBy="Public" />
        </>
    )
}

export default InvestorHistory